import { createContext, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LOGIN_ROUTE } from "../routes/web/rootRoutes";
import { useDispatch } from "react-redux";
import { resetUserProfile } from "../store/slice/globalStore";
import authManager from "../utils/authManager";
import { resetUserData } from "../store/slice/userSlice";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const handleLogout = async () => {
    authManager.deleteAccessToken();
    dispatch(resetUserProfile(null));
    dispatch(resetUserData(null));
    const currentPath = location.pathname + location.search;
    navigate(`${LOGIN_ROUTE}?refer=${encodeURIComponent(currentPath)}`);
  };

  return (
    <AuthContext.Provider value={{ handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
